/* eslint-disable react-hooks/exhaustive-deps */
import { PureComponent, Component, useEffect, useState } from 'react';
import { useTranslation, withTranslation } from 'react-i18next';
import { isBrowser, isTablet } from 'react-device-detect';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Formik } from 'formik';
import { isEmpty } from 'lodash';

import {
  Button,
  Divider,
  Form,
  Icon,
  Input,
  Modal,
  Segment,
  Tab,
} from 'semantic-ui-react';

import plusOutline from '../../../../assets/add-icon-white-bg.svg';
import addIcon from '../../../../assets/add-icon.svg';
import { CustomTable } from '../../../../components';

import {
  CustomCheckbox,
  CustomInput,
  CustomTextArea,
} from '../../../../components/form';

import MultiLanguageInput from '../../../../components/form/inputs/multiLanguageInput';
import MultiLanguageTextArea from '../../../../components/form/inputs/multiLanguageTextArea';

import {
  getOrgVenuesTypesWithTranslations,
  postVenueTypes,
  updateVenueType,
} from '../../../../store/actions';

import {
  initialValues,
  venueTypeValidation,
  convertToBackendFormat,
  convertFromBackendFormat,
} from '../../../../validations/addVenueTypeValidation';

import { SUPPORTED_LANGUAGES } from '../../../../i18n';
import { authMsg } from '../../../../utils/auth';

export default class VenueTypes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
  }

  componentDidMount() {
    const { getOrgVenuesTypesWithTranslations } = this.props;
    getOrgVenuesTypesWithTranslations();
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  render() {
    const { modal } = this.state;
    const { postVenueTypes, orgVenueTypesWithTranslations } = this.props;
    const { t } = this.props;

    return (
      <div>
        <div className="outcome-admin-padded">
          <div className="button-outcome">
            <Modal
              open={modal}
              onOpen={() => this.toggle()}
              closeIcon={
                <Icon
                  onClick={() => this.toggle()}
                  name="close"
                  className="closeicon"
                />
              }
              size="small"
              trigger={
                <Button className="Primary-Button">
                  <div className="add-icon-activity-add">
                    <img className="icons-add" src={addIcon} alt="icon" />
                    <div className="add-text">
                      {t('admin.system_settings.venue_types.add_venue_type')}
                    </div>
                  </div>
                </Button>
              }
              className="create-venue-type"
            >
              <Modal.Header>
                {t('admin.system_settings.venue_types.create_venue_type')}
              </Modal.Header>
              <Modal.Content>
                <CreateVenueForm
                  toggle={() => this.toggle()}
                  {...this.props}
                  postVenueTypes={postVenueTypes}
                  isEdit={false}
                  t={t}
                />
              </Modal.Content>
            </Modal>
          </div>
        </div>
        <div className="industry-list-container">
          {!isEmpty(orgVenueTypesWithTranslations) && (
            <div>
              <div className="gap-between-windows-help">
                <VenueList
                  {...this.props}
                  dataSource={orgVenueTypesWithTranslations}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}
class EditVenueModalBase extends PureComponent {
  constructor(props) {
    super(props);
    const { i18n } = this.props;
    this.state = {
      modal: false,
      form: {
        name: '',
        description: '',
        isOnline: '',
      },
    };
  }

  editSelectedVenue(form) {
    const convertedForm = convertFromBackendFormat(form);
    this.setState({
      form: convertedForm,
    });
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  render() {
    const { modal, form } = this.state;
    const { t, item } = this.props;

    return (
      <Modal
        open={modal}
        onOpen={() => this.toggle()}
        closeIcon={
          <Icon
            onClick={() => this.toggle()}
            name="close"
            className="closeicon"
          />
        }
        size="small"
        trigger={
          <label
            className="activity-actions-warn mb-0"
            onClick={() => this.editSelectedVenue(item)}
          >
            {t('actions.edit')}
          </label>
        }
        className="edit-venue-type"
      >
        <Modal.Header>
          {t('admin.system_settings.venue_types.edit_venue_type')}
        </Modal.Header>
        <Modal.Content>
          <CreateVenueForm
            {...this.props}
            form={form}
            toggle={() => this.toggle()}
            isEdit={true}
          />
        </Modal.Content>
      </Modal>
    );
  }
}

const EditVenueModal = withTranslation()(EditVenueModalBase);

class VenueListBase extends PureComponent {
  constructor(props) {
    super(props);
    const { t, i18n } = this.props;

    this.state = {
      columns: [
        {
          title: t('common.name'),
          render: (data) => {
            return (
              <div className="venue-name">
                {data.name}
                {data.featureFlag === 'environmental_tester' && (
                  <span
                    style={{
                      marginLeft: 8,
                      fontSize: 10,
                      padding: '2px 6px',
                      background: '#d1fae5',
                      color: '#065f46',
                      borderRadius: 4,
                      fontWeight: 600,
                    }}
                  >
                    ENV
                  </span>
                )}
              </div>
            );
          },
          width: 9,
        },
        {
          title: t('common.created_date'),
          render: (data) => {
            return (
              <div>
                {new Intl.DateTimeFormat(i18n.language, {
                  year: 'numeric',
                  month: 'short',
                  day: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit',
                  hour12: true,
                }).format(new Date(data.createdAt))}
              </div>
            );
          },
          width: 3,
        },
        {
          title: t('common.updated_date'),
          render: (data) => {
            return (
              <div>
                {new Intl.DateTimeFormat(i18n.language, {
                  year: 'numeric',
                  month: 'short',
                  day: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit',
                  hour12: true,
                }).format(new Date(data.updatedAt))}
              </div>
            );
          },
          width: 3,
        },
        {
          title: '',
          render: (data) => {
            return (
              <div className="venue-edit">
                <EditVenueModal item={data} {...this.props} {...this.props} />
              </div>
            );
          },
          textAlign: isBrowser || isTablet ? 'center' : null,
          width: 1,
        },
      ],
      currentPage: 1,
    };
  }

  render() {
    const { t, vLoading, dataSource } = this.props;
    const { columns } = this.state;

    return (
      <Segment
        className="content-segment"
        loading={vLoading}
        disabled={vLoading}
      >
        <CustomTable
          header
          customClass="super-admin-table tbody-hover"
          columns={columns}
          data={dataSource}
          emptyMessage={t('common.no_tooltips')}
          keyExtractor={(item, index) => item.id}
        />
      </Segment>
    );
  }
}

const VenueList = withTranslation()(VenueListBase);

const CreateVenueForm = ({
  form,
  toggle,
  venueTypeLoading,
  isEdit,
  updateVenueType,
  postVenueTypes,
  t,
}) => {
  const [isOnline, setIsOnline] = useState(false);
  const [isEnvironmentalTester, setIsEnvironmentalTester] = useState(false);
  const [currentLanguage, setCurrentLanguage] = useState('en');
  const [venueTypeOptionsArr, setVenueTypeOptionsArr] = useState(
    !isEdit
      ? [
          {
            id: null,
            name: { en: '' },
          },
        ]
      : []
  );

  useEffect(() => {
    if (form && isEdit) {
      // The form.venueOptions should already be in the correct format from convertFromBackendFormat
      const options =
        form.venueOptions?.map((item, index) => {
          // If item is already in correct format (from convertFromBackendFormat)
          if (item && typeof item === 'object' && item.name) {
            return {
              id: item.id,
              name: item.name,
            };
          }
          // Fallback for unexpected formats
          return {
            id: null,
            name: typeof item === 'string' ? { en: item } : { en: '' },
          };
        }) || [];

      setVenueTypeOptionsArr(options);
    }
  }, [form, isEdit]);

  const handleAddNewVenueTypeOption = () => {
    setVenueTypeOptionsArr([
      ...venueTypeOptionsArr,
      {
        id: null, // New options don't have IDs yet
        name: { en: '' },
      },
    ]);
  };

  const onSubmit = async (values) => {
    try {
      // Convert multilingual data to backend format
      const legacyData = convertToBackendFormat(values);

      // Process venue options for multilingual support
      const processedVenueOptions = venueTypeOptionsArr
        .filter((item) => item.name?.en?.trim()) // Only include items with English names
        .map((item) => ({
          ...item,
          name: item.name?.en?.trim(), // For legacy API compatibility
        }));

      // Add venue options translations to the translations object
      if (processedVenueOptions.length > 0) {
        legacyData.translations.venueOptions = venueTypeOptionsArr
          .filter((item) => item.name?.en?.trim())
          .map((item) => item.name);
      }

      if (isEdit) {
        // Only validate venue options that actually exist and are not empty
        // Allow existing venue types to be updated even if some options are missing translations
        let hasInvalidOptions = false;
        const invalidOptions = [];

        venueTypeOptionsArr.forEach((item, index) => {
          // Only validate if the option has some content (not completely empty)
          if (item.name && typeof item.name === 'object') {
            const hasAnyContent = Object.values(item.name).some(
              (val) => val && val.trim()
            );
            if (
              hasAnyContent &&
              (!item.name.en || item.name.en.trim() === '')
            ) {
              hasInvalidOptions = true;
              invalidOptions.push(index + 1);
            }
          }
        });

        if (hasInvalidOptions) {
          return authMsg(
            'error',
            `${t('admin.system_settings.venue_types.venue_options_must_have_english_text', { value: invalidOptions.join(', ') })}`
          );
        }

        const data = {
          ...legacyData,
          venueOptions: processedVenueOptions,
          isOnline: isOnline,
          featureFlag: isEnvironmentalTester ? 'environmental_tester' : null,
        };

        await updateVenueType(form.id, data);
      } else {
        const venueOptions = processedVenueOptions.map((item) => item.name);

        if (venueOptions.length > 0) {
          legacyData.venueOptions = venueOptions;
        }
        legacyData.featureFlag = isEnvironmentalTester
          ? 'environmental_tester'
          : null;
        await postVenueTypes(legacyData);
      }
      toggle();
    } catch (error) {
      console.error('Venue Type Create Submit ~~', error);
    }
  };

  const onChangeFilter = () => {
    setIsOnline(!isOnline);
  };

  useEffect(() => {
    form && setIsOnline(form.isOnline);
    form &&
      setIsEnvironmentalTester(form.featureFlag === 'environmental_tester');
  }, [form]);

  const onDeleteOption = (optionIndex) => {
    const updatedVenueTypeOptionsArr = venueTypeOptionsArr.filter(
      (item, index) => index !== optionIndex
    );
    setVenueTypeOptionsArr(updatedVenueTypeOptionsArr);
  };

  const onChangeOptions = (data, optionIndex, language = 'en') => {
    const updatedValue = venueTypeOptionsArr.map((item, index) => {
      if (index === optionIndex) {
        return {
          id: item.id,
          name: {
            ...item.name,
            [language]: data,
          },
        };
      }
      return item;
    });
    setVenueTypeOptionsArr(updatedValue);
  };

  // Get reference values for translation
  const getReferenceValue = (fieldName, values) => {
    if (currentLanguage === 'en') return '';
    return values[fieldName]?.en || '';
  };

  const getVenueTypeOptionReferenceValue = (item) => {
    if (currentLanguage === 'en') return '';
    return item.name?.en || '';
  };

  return (
    <div className="multilingual-venue-form">
      <Formik
        onSubmit={(values) => onSubmit(values)}
        initialValues={initialValues(form)}
        validationSchema={venueTypeValidation(t)}
        context={{ isMultiLang: true }}
      >
        {({ handleSubmit, values }) => {
          // Create language tabs with shared form state
          const languageTabs = SUPPORTED_LANGUAGES.map((lang) => ({
            menuItem: {
              key: lang.locale,
              content: (
                <span>
                  {lang.flag} {lang.name}
                  {lang.locale === 'en' && (
                    <span style={{ color: '#f39c12' }}> *</span>
                  )}
                </span>
              ),
            },
            render: () => (
              <Tab.Pane key={lang.locale}>
                <Form onSubmit={handleSubmit}>
                  <div className="container">
                    <MultiLanguageInput
                      id="name"
                      name="name"
                      placeholder={t('formulary.placeholder.enter_title')}
                      labelText={t('formulary.title')}
                      requiredStar
                      currentLanguage={lang.locale}
                      referenceValue={getReferenceValue('name', values)}
                    />

                    {(!isEdit || venueTypeOptionsArr.length > 0) && (
                      <div>
                        <label>
                          {t(
                            'admin.system_settings.venue_types.venue_type_options'
                          )}
                        </label>
                      </div>
                    )}

                    {venueTypeOptionsArr.map((item, index) => {
                      const key = `venueOptions${index}`;
                      const isExist = item.id > 0;

                      return (
                        <div className="d-flex add-venue-sub-label" key={key}>
                          <div
                            className="sub-options-container"
                            style={{ width: '100%' }}
                          >
                            <Input
                              id={key}
                              name={key}
                              className="edit-venue-type-input"
                              placeholder=""
                              onChange={(e) =>
                                onChangeOptions(
                                  e.target.value,
                                  index,
                                  lang.locale
                                )
                              }
                              value={item.name?.[lang.locale] || ''}
                              icon={
                                !isExist && venueTypeOptionsArr.length > 1 ? (
                                  <div className="delete-btn">
                                    <Icon
                                      onClick={() => onDeleteOption(index)}
                                      name="trash"
                                    />
                                  </div>
                                ) : null
                              }
                            />
                            {getVenueTypeOptionReferenceValue(item) && (
                              <div className="reference-text">
                                <small className="text-muted">
                                  {t('common.reference')}: "
                                  {getVenueTypeOptionReferenceValue(item)}"
                                </small>
                              </div>
                            )}
                          </div>
                        </div>
                      );
                    })}

                    <div className="d-flex align-items-end flex-column">
                      <div>
                        <Button
                          onClick={handleAddNewVenueTypeOption}
                          className="btn-add-ref"
                          type="button"
                        >
                          <span>
                            <img
                              className="plus-icon"
                              alt="plus"
                              src={plusOutline}
                            />
                            <div className="add-button-text">
                              {t('specific_actions.add_more_options')}
                            </div>
                          </span>
                        </Button>
                      </div>
                    </div>

                    <MultiLanguageTextArea
                      id="description"
                      name="description"
                      placeholder={t(
                        'admin.system_settings.venue_types.enter_sector_type_description'
                      )}
                      labelText={t('common.description')}
                      requiredStar
                      currentLanguage={lang.locale}
                      referenceValue={getReferenceValue('description', values)}
                    />

                    {isEdit && (
                      <CustomCheckbox
                        className="check-box"
                        id="isOnline"
                        name="isOnline"
                        label={t(
                          'admin.system_settings.venue_types.venue_no_street_address'
                        )}
                        checked={isOnline}
                        onChange={onChangeFilter}
                      />
                    )}
                    <CustomCheckbox
                      className="check-box"
                      id="isEnvironmentalTester"
                      name="isEnvironmentalTester"
                      label={t(
                        'admin.system_settings.venue_types.environmental_tester_only'
                      )}
                      checked={isEnvironmentalTester}
                      onChange={() =>
                        setIsEnvironmentalTester(!isEnvironmentalTester)
                      }
                    />
                  </div>

                  <Divider section />
                  <div className="actions">
                    <Button
                      className="Secondary-Button"
                      type="button"
                      onClick={toggle}
                    >
                      {t('actions.cancel')}
                    </Button>
                    <Button
                      content={isEdit ? t('actions.update') : t('actions.save')}
                      type="submit"
                      className="Primary-Button"
                      loading={venueTypeLoading}
                      disabled={venueTypeLoading}
                    />
                  </div>
                </Form>
              </Tab.Pane>
            ),
          }));

          return (
            <Tab
              panes={languageTabs}
              onTabChange={(e, { activeIndex }) => {
                const selectedLang = SUPPORTED_LANGUAGES[activeIndex];
                setCurrentLanguage(selectedLang.locale);
              }}
            />
          );
        }}
      </Formik>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    orgVenueTypesWithTranslations: state.extra.orgVenueTypesWithTranslations,
    venueTypeLoading: state.admin.venueTypeLoading,
    venueTypeLimit: state.admin.venueTypeLimit,
    vLoading: state.admin.vLoading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      postVenueTypes,
      updateVenueType,
      getOrgVenuesTypesWithTranslations,
    },
    dispatch
  );
};

VenueTypes = connect(mapStateToProps, mapDispatchToProps)(VenueTypes);

// Wrap with translation HOC
const VenueTypesWithTranslation = (props) => {
  const { t } = useTranslation();
  return <VenueTypes {...props} t={t} />;
};

export { VenueTypesWithTranslation as VenueTypes };
